import {MarkdownEditHistoryViewer} from '@github-ui/markdown-edit-history-viewer/MarkdownEditHistoryViewer'
import type {SxProp} from '@primer/react'

import {ActivityHeader} from './ActivityHeader'
import {CommentActions, type CommentActionsProps} from './CommentActions'

export type CommentHeaderProps = Omit<CommentActionsProps, 'editHistoryComponent'> & {
  avatarUrl: string
  userAvatar?: JSX.Element
  additionalHeaderMessage?: JSX.Element
  viewerDidAuthor?: boolean
  commentSubjectAuthorLogin?: string
  hideActions?: boolean
  isReply?: boolean
  commentAuthorType?: string
  headingProps?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  }
} & SxProp

export function CommentHeader({hideActions, ...props}: CommentHeaderProps) {
  const editHistoryComponent = <MarkdownEditHistoryViewer editHistory={props.comment} />
  return (
    <ActivityHeader
      {...props}
      actions={hideActions ? undefined : <CommentActions {...props} editHistoryComponent={editHistoryComponent} />}
    />
  )
}

try{ CommentHeader.displayName ||= 'CommentHeader' } catch {}